import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getData } from "../../services/generalService";
import { RightPartyLookupObject } from "../../utils/types";

const initialState: RightPartyLookupObject = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getRightPartyDetailsLookup = createAsyncThunk(
  "getRightPartyDetailsLookup",
  async (url: string, thunkAPI) => {
    try {
      const data = await getData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const rightPartyLookupSlice = createSlice({
  name: "rightPartyDetailslookup",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder

      .addCase(getRightPartyDetailsLookup.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRightPartyDetailsLookup.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getRightPartyDetailsLookup.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default rightPartyLookupSlice.reducer;
